/* eslint-disable import/no-cycle */
import React from "react"
import PropTypes from "prop-types"
import { Paper } from "@material-ui/core"
import { WIDGET_TYPES } from "../../widgets/types"
import DashboardWidget from "../../component/widgets/DashboardWidget"
import BookmarkWidget from "../../component/widgets/BookmarkWidget"

function Widget({ type, alias, ...others }) {
  switch (type) {
    case WIDGET_TYPES.DASHBOARD:
      return (
        <DashboardWidget
          widgetId={alias}
          TableProps={{ renderTitle: () => "" }}
          ChartContainerProps={{ component: Paper, elevation: 0 }}
          {...others}
        />
      )
    case WIDGET_TYPES.BOOKMARK:
      return (
        <BookmarkWidget
          widgetId={alias}
          TableProps={{ renderTitle: () => "" }}
          ChartContainerProps={{ component: Paper, elevation: 0 }}
          {...others}
        />
      )
    // case DATE_SELECTOR: return <DateSelectorWidget widgetId={alias} {...others} />
    // case ASSET_SELECTOR: return <AssetSelector widgetId={alias} {...others} />
    default:
      throw new Error(
        `Unknown declared widget type < ${type} > in widget configuration`
      )
  }
}

Widget.propTypes = {
  type: PropTypes.string.isRequired,
  alias: PropTypes.string.isRequired
}

export default Widget
